const LEGACY_SETTINGS_MODAL_HASH_PREFIX = '#settings_tab=default:';
const SETTINGS_MODAL_HASH_PREFIX = '#settings_tab-default-';

function normalizeSettingsModalHashTab(tabTarget = '') {
    const normalized = (tabTarget || '').toString().trim().replace(/^#/, '');

    return normalized || 'settings-content';
}

function migrateLegacySettingsModalHash() {
    const hash = (window.location.hash || '').trim();

    if (!hash.startsWith(LEGACY_SETTINGS_MODAL_HASH_PREFIX)) {
        return;
    }

    const nextHash = `${SETTINGS_MODAL_HASH_PREFIX}${normalizeSettingsModalHashTab(hash.slice(LEGACY_SETTINGS_MODAL_HASH_PREFIX.length))}`;
    const nextUrl = `${window.location.origin}${window.location.pathname}${window.location.search}${nextHash}`;

    window.history.replaceState({}, document.title, nextUrl);
}

migrateLegacySettingsModalHash();
